<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getDomain, getConfigFromLocalStorage, setPageTitle, setFavicon } from '@/utils/webConfig';

export default {
  name: 'App',
  async mounted() {
    // 如果是大客户，从缓存中获取配置
    if (this.isBigCustomer) {
      const hostname = getDomain();

      // 从localStorage中读取缓存的配置
      const cachedConfig = getConfigFromLocalStorage(hostname);
      setPageTitle(cachedConfig && cachedConfig.merchantName);
      if (cachedConfig && cachedConfig.webLogoUrl) {
        setFavicon(cachedConfig.webLogoUrl);
      }
    }
  },
  computed: {
    isBigCustomer() {
      const { hostname, port } = window.location;
      return hostname !== 'www.youjiexian.com' || port === "9988";
    }
  },
  provide() {
    return {
      isBigCustomer: this.isBigCustomer
    };
  }
}
</script>

<style></style>
